const resources = {
  "en": {
    "featureHighlights": {
      "title": "Jump back into your finances",
      "subtitle": "Choose a workflow to stay on track.",
      "open": "Open",
      "descriptions": {
        "transactionsHub": "Capture expenses and income quickly from a centralized workspace.",
        "financeAnalysis": "Separate ledger movement, excluded rows, and day-to-day cashflow once your categories and transaction history are ready.",
        "recurrentHub": "Manage recurring income and expenses from one hub for predictable planning.",
        "tasksToConfirm": "Review pending tasks that need your confirmation so nothing critical stalls.",
        "forecast": "Visualize upcoming cash flow to stay ahead of surprises.",
        "tempoMint": "Capture quick wins in TempoMint and keep your finance rhythm steady.",
        "debtPayoff": "Plan payoff milestones and compare strategies to stay informed.",
        "forecastSummary": "Compare scenarios side by side with the forecast summary view.",
        "forecastSummaryCalendar": "See forecast totals mapped on the calendar to catch busy weeks in advance.",
        "budgets": "Review planned versus actual spending to fine-tune your budgets in minutes.",
        "myInsights": "Log personal finance insights so you can repeat what works.",
        "financeGoals": "Track goal progress and planned contributions in one place.",
        "supportHelp": "Reach support or browse help resources when you need a hand.",
        "inviteFriend": "Share Finance with a friend and unlock rewards together."
      }
    }
  },
  "uk": {
    "featureHighlights": {
      "title": "Поверніться до фінансових задач",
      "subtitle": "Оберіть сценарій і продовжуйте рухатися вперед.",
      "open": "Відкрити",
      "descriptions": {
        "transactionsHub": "Швидко фіксуйте витрати й доходи в єдиному робочому просторі.",
        "financeAnalysis": "Розділяйте весь рух у ledger, виключені рядки та повсякденний cashflow, коли вже є транзакції й власні категорії.",
        "tasksToConfirm": "Переглядайте завдання, що очікують на підтвердження, аби жодна критична дія не зупинилася.",
        "forecastSummaryCalendar": "Бачте підсумки прогнозу на календарі, щоб завчасно помічати напружені тижні.",
        "recurrentHub": "Керуйте регулярними доходами й витратами в одному хабі для передбачуваного планування.",
        "forecast": "Візуалізуйте майбутні грошові потоки, щоб уникати неприємних сюрпризів.",
        "tempoMint": "Фіксуйте швидкі перемоги в TempoMint і тримайте фінансовий ритм.",
        "debtPayoff": "Плануйте етапи погашення та порівнюйте стратегії, щоб залишатися в курсі.",
        "forecastSummary": "Порівнюйте сценарії поруч у зведенні прогнозу.",
        "budgets": "Перевіряйте планові та фактичні витрати, щоб оперативно коригувати бюджети.",
        "myInsights": "Записуйте власні інсайти, аби повторювати успішні рішення.",
        "financeGoals": "Відстежуйте прогрес цілей і заплановані внески в одному місці.",
        "supportHelp": "Звертайтеся до підтримки або переглядайте довідку, коли потрібна допомога.",
        "inviteFriend": "Поділіться Finance з другом і отримайте винагороди разом."
      }
    }
  }
};

export default resources;
